import { render } from "./error-boundary.vue?vue&type=template&id=7c0fbd04"
import script from "./error-boundary.vue?vue&type=script&lang=js"
export * from "./error-boundary.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604161159/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__